<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="tms">N</span>
          <input
            type="text"
            :placeholder="$t('search')"
            v-model="searchActivities"
          />
        </div>
        <span class="tms modal-close" @click="close()">F</span>
      </div>

      <div class="modal-content">
        <p
          class="modal-content-no-results"
          v-if="activities.length && !filteredActivities.length"
        >
          {{ $t("no-results-for") }} '
          <strong>{{ this.searchActivities }}</strong
          >'
        </p>
        <div
          v-else-if="!activities.length"
          class="modal-content-template"
          @click="triggerFileInput()"
        >
          <img
            class="modal-content-template-img desktop"
            :src="getImg(false)"
            :alt="$t('table-structure')"
          />
          <img
            class="modal-content-template-img mobile"
            :src="getImg(true)"
            :alt="$t('table-structure')"
          />
        </div>
        <table v-else>
          <thead>
            <tr>
              <th>Смр</th>
              <th>Изпълнено</th>
              <th>Планирано</th>
              <th v-if="!isCommingFromReport"></th>
              <th v-if="!isCommingFromReport"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(a, i) in filteredActivities"
              :key="`addActivities-${i}-${a._id}`"
              :title="a.name"
              @click="setSelected(a)"
              :class="{
                'tr--reports': isCommingFromReport,
                'tr--additional': a.isAdditional,
              }"
            >
              <!-- 'tr--disabled': getSelectedActivities(a), -->
              <td>
                <div class="activity-name">
                  <Checkbox v-if="isCommingFromReport" :value="a.isSelected" @input="setSelected(a)"/>
                  <span v-if="a.isAdditional">⚡</span>{{ a.name }}
                </div>
              </td>
              <td>
                <p class="hours-status" :class="smrStatus(a)">
                  {{ a.totalUsed }}
                </p>
              </td>
              <td>{{ a.quantity }}</td>
              <td v-if="!isCommingFromReport">
                <span class="tms edit" @click="editActivity(i)" title>c</span>
              </td>
              <td v-if="!isCommingFromReport">
                <span class="tms" @click="deleteActivity(i)" title>b</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <div
          class="add-row"
          v-if="isCommingFromReport"
          @click="isEditItemModalOpened = true"
        >
          <span class="icon">+</span>
          <p>{{ $t("new-activity") }}</p>
        </div>
        <div v-else>
          <!-- EMPTY DIV FOR THE SPACE-AROUND RULE TO WORK -->
        </div>
        <div class="btns">
          <button
            class="btn btn-excel"
            @click="triggerFileInput()"
            v-if="!isCommingFromReport"
          >
            <span class="tms">E</span>
            {{ $t("new-file") }}
          </button>
          <input
            ref="uploadActivities"
            class="input-hide"
            type="file"
            value="C:\fakepath"
            @change="handleFile"
          />

          <button class="btn btn-new" @click="save()">
            <!-- v-if="!isCommingFromReport" -->
            <span class="tms">Y</span>
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </div>
    <EditInputModal
      v-if="isEditInputModalOpened"
      :isComingFromActivities="true"
    ></EditInputModal>
    <EditItemModal
      v-if="isEditItemModalOpened"
      :isComingFromActivities="true"
      type="activity"
      :obj="activities[selectedIndex]"
      @create="handleAdd"
      @edit="handleEditActivity"
      @close="closeEditItemModalModal"
    />
  </div>
</template>

<script>
import XLSX from "xlsx";
import EditInputModal from "./EditInputModal";
import EditItemModal from "./EditItemModal";
import Checkbox from "../shared/Checkbox.vue";
export default {
  components: {
    EditInputModal,
    EditItemModal,
    Checkbox,
  },
  props: [
    "selectedActivities",
    "incomingActivities",
    "incomingBudget",
    "isCommingFromReport",
    "companyId",
    "projectId",
    "objectId",
    "partId",
  ],
  watch: {
    incomingActivities() {
      this.selectedActivities = this.activities.filter((a) => a.isSelected)
      this.initActivities();
    },
  },
  data() {
    return {
      isEditInputModalOpened: false,
      isEditItemModalOpened: false,
      activities: [],
      searchActivities: "",
      selectedIndex: undefined,
      totalSumActivities: 0,
    };
  },
  computed: {
    filteredActivities() {
      return this.filterActivities();
    },
  },
  methods: {
    smrStatus(a) {
      if (Number(a.totalUsed) === Number(a.plannedHours))
        return "hours-status--green";
      if (Number(a.totalUsed) > Number(a.plannedHours))
        return "hours-status--orange";
      else return "hours-status--red";
    },
    getImg() {
      return `${process.env.VUE_APP_STATIC_URI}/table_help_a.png`;
    },
    triggerFileInput() {
      this.$refs.uploadActivities.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? "binary" : "array" });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            const values = Object.values(rows[row]);

            for (let v of values) {
              let cols = Object.keys(v);

              for (let c of cols) {
                if (
                  (c.toLocaleLowerCase() === "кол." ||
                    c.toLocaleLowerCase() === "ед.цена" ||
                    c.toLocaleLowerCase() === "стойност на заработка") &&
                  typeof v[c] !== "number"
                )
                  return this.$snotify.error(
                    `Невалидна стойност в клетка Кол или Ед.цена или Стойност на заработка`
                  );
              }

              if (cols.length !== 5) {
                return this.$snotify.error(this.$t("table-warning-missing"));
              }
            }
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes("наименование") ||
                  keys[i].toLowerCase().includes("ед.") ||
                  keys[i].toLowerCase().includes("кол.") ||
                  keys[i].toLowerCase().includes("стойност на заработка") ||
                  keys[i].toLowerCase().includes("eд.цена.")
                )
              ) {
                console.log("error", keys);
                this.$snotify.error(this.$t("table-warning-activity"));
                return;
              }
            }
            // ROW OBJECT
            for (let item in rows[row]) {
              // ROW DATA
              if (!isNaN(rows[row][item][Object.keys(rows[row][item])[2]])) {
                this.totalSumActivities +=
                  rows[row][item][Object.keys(rows[row][item])[2]] *
                  rows[row][item][Object.keys(rows[row][item])[3]];

                this.activities.push({
                  name: rows[row][item][
                    Object.keys(rows[row][item])[0]
                  ].toString(),
                  unit: rows[row][item][Object.keys(rows[row][item])[1]],
                  quantity:
                    Number(
                      rows[row][item][Object.keys(rows[row][item])[2]]
                    ).toFixed(2) || 0,
                  earnings:
                    Number(
                      rows[row][item][Object.keys(rows[row][item])[3]]
                    ).toFixed(2) || 0,
                  price:
                    Number(
                      rows[row][item][Object.keys(rows[row][item])[4]]
                    ).toFixed(2) || 0,
                  totalUsed: 0,
                });
              }
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error(this.$t("table-warning-xls"));
      }

      // input @change was not reacting to new files
      e.target.value = null;
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach((sheetName) => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterActivities() {
      return this.activities.filter((a) => {
        return a.name
          .toLowerCase()
          .includes(this.searchActivities.toLowerCase());
      });
    },
    // Handle added activity from EditInput
    handleAdd(newActivity) {
      // this.activities.unshift(newActivity);
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          const company = response.data;
          // get index of selected project
          const indexOfObject = company.objects.findIndex(
            (p) => p._id === this.objectId
          );
          // get index of selected object
          const indexOfPart = company.objects[indexOfObject].parts.findIndex(
            (o) => o._id === this.partId
          );
          company.objects[indexOfObject].parts[indexOfPart].activities.push(
            newActivity
          );

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success(this.$t("success-activity"));
              this.$parent.$emit("getActivitiesAgain");
            })
            .catch((error) => {
              console.log(error);
              this.$snotify.error(this.$t("something-went-wrong"));
            });
        })
        .catch((error) => console.log(error));
    },
    editActivity(i) {
      this.selectedIndex = i;
      this.isEditItemModalOpened = true;
    },
    handleEditActivity(a) {
      this.activities[this.selectedIndex].name = a.name;
      this.activities[this.selectedIndex].unit = a.unit;
      this.activities[this.selectedIndex].price = a.price;
      this.activities[this.selectedIndex].quantity = a.quantity;
      this.activities[this.selectedIndex].updateInReports = true;

      this.$set(
        this.activities,
        this.selectedIndex,
        this.activities[this.selectedIndex]
      );
    },
    closeEditItemModalModal() {
      this.isEditItemModalOpened = false;
      this.selectedIndex = null;
    },
    deleteActivity(i) {
      this.totalSumActivities -=
        this.activities[i].quantity * this.activities[i].price;
      this.activities.splice(i, 1);
    },
    getSelectedActivities() {
      if (this.isCommingFromReport && this.selectedActivities) {
        for (let a of this.activities) {
          for (let sa of this.selectedActivities) {
            if (a._id == sa._id) this.$set(a, "isSelected", true), this.$set(a, 'old', true), this.$set(a, 'quantity', sa.quantity);
          }
        }
      }
    },
    close() {
      this.$parent.$emit("closeAddActivitiesModal");
    },
    setSelected(a) {
      if (this.isCommingFromReport) {
        this.$set(a, "isSelected", !a.isSelected);
      }
    },
    saveSingle(a) {
      this.$parent.$emit("saveAddActivitiesModal", {
        _id: a._id,
        name: a.name.toString(),
        unit: a.unit,
        price: a.price,
        isAdditional: a.isAdditional,
      });
    },
    save() {
      let results = [];
      if (this.isCommingFromReport) {
        results = this.activities.filter((a) => a.isSelected);
      } else {
        results = this.activities;
      }

      this.$parent.$emit(
        "saveAddActivitiesModal",
        results,
        !this.isCommingFromReport ? this.totalSumActivities : 0
      );
    },
    initActivities() {
      this.activities = this.$cloneDeep(this.incomingActivities);

      // this.activities.sort((x, y) => {
      //   return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      // });
      this.getPartSmrTotals();
    },
    getPartSmrTotals(act) {
      if (this.partId && this.objectId) {
        let url = `${process.env.VUE_APP_BASE_URI}/report/totalSmr/${
          this.companyId
        }/${this.objectId}/${this.partId}?fromReport=${act ? act._id : true}`;
        this.$http
          .get(url)
          .then((res) => {
            if (res.data.length) {
              let filteredActivities = [];
              for (let r of res.data) {
                for (let a of this.activities) {
                  if (a._id && r._id.toString() === a._id.toString()) {
                    (r.note = a.note),
                      (r.price = a.price),
                      (r.quantity = a.quantity),
                      filteredActivities.push(r);
                  }
                }
              }

              this.activities = filteredActivities;
            if(this.selectedActivities) this.getSelectedActivities();
            }
          })
          .catch((error) => console.log(error));
      }
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
  },
  mounted() {
    if (this.incomingBudget) {
      this.totalSumActivities = this.incomingBudget;
    }
    this.initActivities();

    this.$on("saveMaterialActivityOrMechanization", this.handleAdd);
    this.$on("closeEditInputModal", this.closeEditInputModal);
    this.$eventBus.$on("closeModalFromSpeechRecognition", () => {
      this.close();
    });
  },
  destroyed() {
    this.$off("saveMaterialActivityOrMechanization");
    this.$off("closeEditInputModal");
    this.$eventBus.$off("closeModalFromSpeechRecognition");
  },
};
</script>

<style lang='scss' scoped>
.modal-content {
  flex-wrap: initial;
  flex-direction: column;

  table {
    border-collapse: separate;
    border-spacing: 0 10px;
    width: 100%;

    tbody {
      tr {
        &:nth-of-type(odd):not(.tr--additional) {
          background: #e4eaf5;
        }
      }
    }
    tr {
      height: 50px;
      text-align: left;

      &.tr--additional {
        background: #f1f4c0;
      }

      &.tr--disabled {
        cursor: default;
        opacity: 0.4;
      }

      &.tr--reports:not(.tr--disabled) {
        cursor: pointer;
        &:hover:not(.tr--disabled) {
          opacity: 0.7;
        }
      }

      td {
        padding: 0 10px;

        &:first-child {
          border-radius: 4px 0 0 4px;
          padding-right: 20px;
          width: 75%;
        }
        &:last-child {
          border-radius: 0 4px 4px 0;
        }

        .activity-name {
          align-items: center;
          display: flex;
        }

        .tms {
          cursor: pointer;
          color: #d80000;
          font-size: 20px;
          opacity: 0.4;
          transition: 0.3s all;

          &:hover {
            opacity: 1;
          }

          &.edit {
            color: #0078d7;
          }
        }
      }
    }
  }

  .modal-content-item {
    padding-right: initial;
    margin-right: initial;
    width: 100%;
  }
}
.model-wrapper {
  justify-content: center;
}
/* .modal-header {
  background: #17643a;
} */
.desktop {
  display: initial;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 90vh;
    overflow: unset;
    width: 90%;

    table {
      min-width: 700px;
    }
  }
  .modal-content-item {
    height: fit-content;
    min-height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
